export default "/images/vendor/flag-icon-css/flags/1x1/bq.svg?6e5b96f6104d2ff9977a1eb9e5c73272";